import { render, staticRenderFns } from "./withdrawal-detail.vue?vue&type=template&id=bbfdd8e6"
import script from "./withdrawal-detail.vue?vue&type=script&lang=js"
export * from "./withdrawal-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports